/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorList,
  Order,
  PaymentRequest,
  WebhookData,
} from '../models';
import {
    ErrorListFromJSON,
    ErrorListToJSON,
    OrderFromJSON,
    OrderToJSON,
    PaymentRequestFromJSON,
    PaymentRequestToJSON,
    WebhookDataFromJSON,
    WebhookDataToJSON,
} from '../models';

export interface AcceptPaymentRequest {
    baseSiteId: string;
    handleId: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface CancelPaymentRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface InitiatePaymentRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ProceedBillwerkPlusPaymentRequest {
    baseSiteId: string;
    webhookData: WebhookData;
    sapCommerceCloudCustomerId?: string;
}

/**
 * PaymentsApi - interface
 * 
 * @export
 * @interface PaymentsApiInterface
 */
export interface PaymentsApiInterface {
    /**
     * Verifies and accepts payment via payment provider
     * @summary Accepts a payment.
     * @param {string} baseSiteId Base site identifier
     * @param {string} handleId Transaction identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    acceptPaymentRaw(requestParameters: AcceptPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>>;

    /**
     * Verifies and accepts payment via payment provider
     * Accepts a payment.
     */
    acceptPayment(requestParameters: AcceptPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order>;

    /**
     * Cancels payment via payment provider
     * @summary Cancels a payment.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    cancelPaymentRaw(requestParameters: CancelPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Cancels payment via payment provider
     * Cancels a payment.
     */
    cancelPayment(requestParameters: CancelPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Initiates a payment for the cart. The response contains details on how to continue the payment.
     * @summary Initiate a payment.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    initiatePaymentRaw(requestParameters: InitiatePaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentRequest>>;

    /**
     * Initiates a payment for the cart. The response contains details on how to continue the payment.
     * Initiate a payment.
     */
    initiatePayment(requestParameters: InitiatePaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentRequest>;

    /**
     * Proceed a payment for Billwerk+.
     * @summary Proceed a payment.
     * @param {string} baseSiteId Base site identifier
     * @param {WebhookData} webhookData 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    proceedBillwerkPlusPaymentRaw(requestParameters: ProceedBillwerkPlusPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Proceed a payment for Billwerk+.
     * Proceed a payment.
     */
    proceedBillwerkPlusPayment(requestParameters: ProceedBillwerkPlusPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

}

/**
 * 
 */
export class PaymentsApi extends runtime.BaseAPI implements PaymentsApiInterface {

    /**
     * Verifies and accepts payment via payment provider
     * Accepts a payment.
     */
    async acceptPaymentRaw(requestParameters: AcceptPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling acceptPayment.');
        }

        if (requestParameters.handleId === null || requestParameters.handleId === undefined) {
            throw new runtime.RequiredError('handleId','Required parameter requestParameters.handleId was null or undefined when calling acceptPayment.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling acceptPayment.');
        }

        const queryParameters: any = {};

        if (requestParameters.handleId !== undefined) {
            queryParameters['handleId'] = requestParameters.handleId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/payments`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * Verifies and accepts payment via payment provider
     * Accepts a payment.
     */
    async acceptPayment(requestParameters: AcceptPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.acceptPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancels payment via payment provider
     * Cancels a payment.
     */
    async cancelPaymentRaw(requestParameters: CancelPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling cancelPayment.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling cancelPayment.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling cancelPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/payments`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancels payment via payment provider
     * Cancels a payment.
     */
    async cancelPayment(requestParameters: CancelPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelPaymentRaw(requestParameters, initOverrides);
    }

    /**
     * Initiates a payment for the cart. The response contains details on how to continue the payment.
     * Initiate a payment.
     */
    async initiatePaymentRaw(requestParameters: InitiatePaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentRequest>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling initiatePayment.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling initiatePayment.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling initiatePayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/payments`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentRequestFromJSON(jsonValue));
    }

    /**
     * Initiates a payment for the cart. The response contains details on how to continue the payment.
     * Initiate a payment.
     */
    async initiatePayment(requestParameters: InitiatePaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentRequest> {
        const response = await this.initiatePaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Proceed a payment for Billwerk+.
     * Proceed a payment.
     */
    async proceedBillwerkPlusPaymentRaw(requestParameters: ProceedBillwerkPlusPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling proceedBillwerkPlusPayment.');
        }

        if (requestParameters.webhookData === null || requestParameters.webhookData === undefined) {
            throw new runtime.RequiredError('webhookData','Required parameter requestParameters.webhookData was null or undefined when calling proceedBillwerkPlusPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/payments/webhooks/billwerk-plus`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebhookDataToJSON(requestParameters.webhookData),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Proceed a payment for Billwerk+.
     * Proceed a payment.
     */
    async proceedBillwerkPlusPayment(requestParameters: ProceedBillwerkPlusPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.proceedBillwerkPlusPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
